import { isEmpty } from 'underscore';

import { View, Utils } from '../vendor/kerneljs';

const MapsPeopleMap = View.extend({

	googleMapsInstance: null,
	mapsIndoorsInstance: null,

	locationService: null,

	initialZoom: 19,

	initialCoords: { lat: 55.6287, lng: 12.647 },

	events: {
		"click .js--route-next": "nextLegHandler",
		"click .js--route-prev": "prevLegHandler"
	},

	initialize:function() {

		const google = window.google
		const mapsindoors = window.mapsindoors


		this.mapElement = this.find('.js--map');
		this.initData = window[this.el.getAttribute('data-id')];

		// Setup google map
		let gmStyles = [
			{ "stylers": [{ "visibility": "off" }] },
			{ "featureType": "water", "stylers": [{ "visibility": "on" }] },
			{ "featureType": "poi", "stylers": [{ "visibility": "off" }] },
			{ "featureType": "transit", "stylers": [{ "visibility": "on" }] },
			{ "featureType": "landscape", "stylers": [{ "visibility": "on" }] },
			{ "featureType": "road", "stylers": [{ "visibility": "on" }] },
			{ "featureType": "administrative", "stylers": [{ "visibility": "on" }] }
		];
		this.googleMapsInstance = new google.maps.Map(this.mapElement, { center: this.initialCoords, zoom: this.initialZoom, styles:gmStyles });

		// Setup MapsIndoors
		let clearColor = "#00000000";
		this.mapsIndoorsInstance = new mapsindoors.MapsIndoors({ map: this.googleMapsInstance, buildingOutlineOptions: { strokeColor: clearColor, fillColor: clearColor}});

		this.mapsIndoorsInstance.setLabelStyle({
			color: '#333',
			shadowBlur: 1,
			shadowColor: '#fff'
		});
		let floorSelectorContainer = document.createElement('div')
		
		new mapsindoors.FloorSelector(floorSelectorContainer, this.mapsIndoorsInstance);

		this.googleMapsInstance.controls[google.maps.ControlPosition.RIGHT_TOP].push(floorSelectorContainer);

		this.locationsService = new mapsindoors.LocationsService();

		this.locationsService.getLocations().then(function() {

			// //LOCATIONS READY, LOAD MAP CONTENT
			if ( this.initData?.route ) this.loadRoute();
			else if ( this.initData?.poi ) this.loadPOIs();
			else this.mapsIndoorsInstance.setFloor(1);

		}.bind(this));

		let moduleScope = this;
		google.maps.event.addListener(this.mapsIndoorsInstance, 'location_click', function(location) {
			moduleScope.poiClickHandler(location);
		});


		// unused once we stop using the maps
		let externalPoiButtons = Utils.find('.js--find-poi');
		Utils.each(externalPoiButtons, function(elem) {
			Utils.on(elem, 'click', function(){
				let poiId = elem.getAttribute('data-poi');
				this.poiFound(poiId, this.initData.poi.zoom);

				Utils.each(externalPoiButtons, function(elem) {
					Utils.removeClass(elem,'is-active');
				});
				Utils.addClass(elem,'is-active');

			}.bind(this));
		}.bind(this));

	},
	poiClickHandler: function(location) {
	
		let contentString = this.createContentString(location);
	
		this.closeCurrentInfoWindow();
	
		this.currentInfoWindow = this.createInfoWindow(contentString, location);
	
		this.addInfoWindowStyleListener();
	
		this.dispatchPoiClickEvent(location.id);
	},
	
	createContentString: function(location) {
		let contentString = '<div class="indoors-map__popout">';
		contentString += '<h3>' + location.properties.name + '</h3>';
	
		if (this.initData.detailedInfoWindow) {
			contentString += this.getDetailedContent(location);
		}
	
		contentString += '</div>';
		return contentString;
	},
	
	getDetailedContent: function(location) {
		let content = '';
		let hasExtraFields = !isEmpty(location.properties.fields);
		let description = this.getField(location.properties.description);
		let floorName = this.getField(location.properties.floorName);
	
		if (hasExtraFields) {
			let fields = location.properties.fields;
			let terminalValue = this.getFieldValue(fields.terminal);
			let openingHoursValue = this.getFieldValue(fields.openinghours);
			let phoneValue = this.getFieldValue(fields.phone);
			let phoneText = this.getFieldText(fields.phone);
			let emailValue = this.getFieldValue(fields.email);
			let emailText = this.getFieldText(fields.email);
	
			content += this.addFieldContent('Terminal: ', terminalValue, 'bodytext-sm');
			content += this.addFieldContent('Etage: ', floorName, 'bodytext-sm');
	
			if (terminalValue || floorName) content += '<br/>';
	
			content += this.addFieldContent('', description, 'bodytext-xs', '<br/>');
			content += this.addFieldContent('', openingHoursValue, 'bodytext-sm', '<br/>');
	
			if (phoneValue || emailValue) {
				content += '<p class="bodytext-sm">';
				content += this.addFieldContent(phoneText + ': ', phoneValue, '');
				content += this.addFieldContent('<br/>' + emailText + ': ', emailValue, '');
				content += '</p>';
			}
		} else if (description) {
			content += '<p class="bodytext-xs">' + description + '</p>';
		}
	
		return content;
	},
	
	addFieldContent: function(label, value, className, suffix = '') {
		return value ? `<p class="${className}">${label}${value}</p>${suffix}` : '';
	},
	
	closeCurrentInfoWindow: function() {
		if (this.currentInfoWindow) {
			try {
				this.currentInfoWindow.close();
			} catch (error) {
				console.log("Error closing info window", error);
			}
		}
	},
	
	createInfoWindow: function(contentString, location) {
		const google = window.google;
		return new google.maps.InfoWindow({
			content: contentString,
			maxWidth: 250,
			maxHeight: 250,
			position: new google.maps.LatLng(location.geometry.coordinates[1], location.geometry.coordinates[0])
		});
	},
	
	addInfoWindowStyleListener: function() {
		const google = window.google;
	
		google.maps.event.addListener(this.currentInfoWindow, 'domready', function() {
			let gmStyleIw = Utils.find('.gm-style-iw');
			try {
				let iw = gmStyleIw[0];
				let iwBackground = iw.previousElementSibling;
				let iwArrow = iwBackground.children[2];
				let iwOuter = iw.parentNode;
	
				iwBackground.children[0].style.display = 'none';
				iwBackground.children[1].style.display = 'none';
				iwBackground.children[3].style.display = 'none';
	
				Utils.addClass(iwArrow, 'gm-style-iw__arrow');
				Utils.addClass(iwOuter, 'gm-style-iw__outer');
			} catch (error) {
				console.log("MapsPeopleMap | info window error", gmStyleIw);
			}
		});
	},
	
	dispatchPoiClickEvent: function(locationId) {
		let poiEvent = new CustomEvent('indoorsmaps:poiclick', { detail: { id: locationId } });
		window.dispatchEvent(poiEvent);
	},

	poiFound: function(poiId, zoom) {
		const google = window.google

		this.locationsService.getLocation(poiId).then(function(detailedData){
			this.poiClickHandler(detailedData);
			this.mapsIndoorsInstance.setFloor(detailedData.properties.floor);
			this.googleMapsInstance.setCenter(new google.maps.LatLng(detailedData.geometry.coordinates[1], detailedData.geometry.coordinates[0]));
			if ( zoom ) this.googleMapsInstance.setZoom(zoom);
		}.bind(this));
	},

	loadPOIs: function() {
		let poiData = this.initData.poi;

		if ( poiData.excludeOthers ) {
			this.mapsIndoorsInstance.setLocationsVisible(false);
		}
		if ( poiData.floor ) {
			this.mapsIndoorsInstance.setFloor(poiData.floor);
		}

		if ( poiData.id) {
			this.mapsIndoorsInstance.find(poiData.id).then(function(){
				this.poiFound(poiData.id, poiData.zoom);
			}.bind(this));
		}
		else if ( poiData.categories ) {
			let categoryCount = poiData.categories.length;

			this.mapsIndoorsInstance.setFloor(poiData.floor);

			switch (categoryCount) {
				case 1:
					this.mapsIndoorsInstance.find({categories: poiData.categories});
				break;
				case 2:
					this.locationsService.getLocations().then(function(locations) {
						let filtered = locations.filter(function(l){
							return l.properties.categories[poiData.categories[0]] && l.properties.categories[poiData.categories[1]];
						});
						filtered.forEach(function(l) {
							this.mapsIndoorsInstance.find(l.id);
						}.bind(this));
					}.bind(this));
				break;
				case 3:
					this.locationsService.getLocations().then(function(locations) {
						let filtered = locations.filter(function(l){
							return l.properties.categories[poiData.categories[0]] && l.properties.categories[poiData.categories[1]] && l.properties.categories[poiData.categories[2]];
						});
						filtered.forEach(function(l) {
							this.mapsIndoorsInstance.find(l.id);
						}.bind(this));

					}.bind(this));
				break;
				default:
					console.log("unexpected categoryCount:" + categoryCount)
			}

			if ( poiData.zoom ) setTimeout(function(){
				this.googleMapsInstance.setZoom(poiData.zoom);
			}.bind(this),4000);

		}
		else if ( this.initData.poi.query ) {
			this.mapsIndoorsInstance.find({q: poiData.query});
		}

	},


	fitBounds: function(location) {
		const google = window.google

		this.currentBounds.extend( new google.maps.LatLng(location.geometry.coordinates[1], location.geometry.coordinates[0]) );
		this.googleMapsInstance.fitBounds(this.currentBounds);
	},

	loadRoute: function() {
		let legCount = this.initData.route.legs ? this.initData.route.legs.length : 0;

		if ( legCount > 0 ) {
			let directionsService = new window.mapsindoors.DirectionsService();
			let directionsRenderer = new window.mapsindoors.DirectionsRenderer({ map: this.googleMapsInstance, mapsindoors: this.mapsIndoorsInstance});

			for (let i = 0; i < legCount; i++) {
				let leg = this.initData.route.legs[i];


				directionsRenderer.setStyle('default', {
					strokeColor: "#fecb00",
					strokeOpacity: 1.0,
					strokeWeight: 10
				});

				directionsRenderer.setStyle('hidden', {
					strokeColor: "#fecb00",
					strokeOpacity: 0.2,
					strokeWeight: 10
				});

				directionsRenderer.setStyle('inactive', {
					visible: false
				});

				directionsService.route(leg).then(
					function (routeData) {
						directionsRenderer.setDirections(routeData);
						directionsRenderer.setLegIndex(0);
					}
				);
			}
		}

		this.mapsIndoorsInstance.setFloor(this.initData.route.legs[0].origin.floor);
	},

	nextLegHandler: function() {
	},
	prevLegHandler: function() {
	},

	setupRouteMarkers: function(directionsRenderer, routeData) {
		let routeStartMarker = new window.google.maps.Marker({map: this.googleMapsInstance});
		let routeEndMarker = new window.google.maps.Marker({map: this.googleMapsInstance});
		let index = 0
		let currentRoute = routeData.routes[0];

		function setLeg(index) {
			let currentLeg = currentRoute.legs[index];
			routeStartMarker.setPosition(currentLeg.end_location);
			routeEndMarker.setPosition(currentLeg.destination);
			directionsRenderer.setLegIndex(index);
		}

		setLeg(0);

		window.google.maps.event.addListener(routeEndMarker, 'click', function() {
			setLeg(++index);
		});
	},

	getFieldValue: function(prop) {
		if ( prop && prop.value !== "" ) return prop.value;
		return null;
	},

	getFieldText: function(prop) {
		if ( prop && prop.text !== "" ) return prop.text;
		return null;
	},

	getField: function(prop) {
		if ( prop && prop !== "" ) return prop;
		return null;
	}

});

(function(){
	const google = window.google

	function mapsLoadHandler() {
		window.googleMapsLoaded = true;
		Utils.each(Utils.find('.js--maps-people-map'), function(elem) {
			new MapsPeopleMap( {el: elem} );
		});
	}
	if ( window["google"] && !window.googleMapsLoaded ) {
		google.maps.event.addDomListener(window, 'load', mapsLoadHandler);
	}
	else {
		mapsLoadHandler();
	}

})();

export default MapsPeopleMap;
